import { useState } from 'react'
import { LoginFormImport } from './Import'
const { RoutesMap, Form, InputGroup, Button, Card, alexa_circle, useFormik, LoginSchema, useNavigate, useDispatch, toast, KeyRound, UserRound, Eye, EyeOff, ArrowRight, Leaf, ButtonLoader, SessionManager, signIn, sidebar } = LoginFormImport

export default function UserLoginForm(props) {

  const { setTogggle } = props

  const [spinner, setSpinner] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const initialValues = {
    phone: '',
    password: '',
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialValues,
    validationSchema: LoginSchema,

    onSubmit: (values, action) => {
      // console.log(values)
      setSpinner(true)
      dispatch(signIn(values)).then((res) => signIn_user(res.payload, action))
    },
  })

  const signIn_user = (res, action) => {

    if (res?.status === 200) {

      SessionManager.setCookie('user_token', `Bearer ${res?.data?.data?.userResponse?.access_token}`, 3)
      SessionManager.setCookie('user', res?.data?.data && JSON.stringify(res?.data?.data?.userResponse), 3)

      toast.success("SignIn Successfully!!..", { position: "bottom-right" })

      dispatch(sidebar({ navigate })).then((res1) => sidebar_res(res1.payload))

    } else if (res?.status === 400) {
      setSpinner(false)
      toast.error(res?.data?.message, { position: "bottom-right" })
    } else if (res?.status === 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  const sidebar_res = (res) => {
    if (res?.status === 200) {
      const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
      SessionManager.setSession('permission', JSON.stringify(permission))
      navigate(RoutesMap.DASHBOARD.path)
      setSpinner(false)
    } else {
      setSpinner(false)
    }
  }

  return (
    <>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100'>
        <Card className="h-100 rounded-start-5 rounded-end-0 border-0" style={{ backgroundColor: '#ffffff' }}>
          <Card.Header className="p-3 text-end border-0" style={{ backgroundColor: 'unset' }}>
            <span className='fs-6 text-muted'>New to Alexa Farms?
              <u className='fw-medium green ms-1' style={{ cursor: 'pointer' }} onClick={() => setTogggle(true)}>Create an Account</u>
            </span>
          </Card.Header>
          <Card.Body className='px-5 d-flex align-items-center'>
            <div className='flex-fill'>
              <div className='text-center'>
                <img src={alexa_circle} alt="logo" className='img-fluid' style={{ height: '120px', objectFit: 'cover' }} />
                <h2 className='green fw-bold mt-3 mb-1'>Welcome Back <Leaf size={20} style={{ color: '#7ed957' }} /></h2>
                <p className='text-muted'>Sign in to access your Alexa Farms dashboard.</p>
              </div>

              <div className='mb-3'>
                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Username'}</Form.Label>
                <InputGroup>
                  <InputGroup.Text className='login_input_icon' id="phone"><UserRound size={18} className='green' /></InputGroup.Text>
                  <Form.Control
                    className='login-input'
                    placeholder="Enter your username"
                    aria-label="Phone"
                    aria-describedby="phone"
                    name='phone'
                    value={values.phone || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </InputGroup>
                {errors.phone && touched.phone ? (<span className='field_error'>{errors.phone}</span>) : null}
              </div>

              <div className='mb-1'>
                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Password'}</Form.Label>
                <InputGroup>
                  <InputGroup.Text className='login_input_icon' id="password"><KeyRound size={18} className='green' /></InputGroup.Text>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    className='login-input'
                    placeholder="Enter your password"
                    aria-label="Password"
                    aria-describedby="password"
                    name='password'
                    value={values.password || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <InputGroup.Text className='login_input_icon' id="password" onClick={() => setShowPassword(!showPassword)} style={{ cursor: 'pointer' }}>
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </InputGroup.Text>
                </InputGroup>
                {errors.password && touched.password ? (<span className='field_error'>{errors.password}</span>) : null}
              </div>

              <div className='text-end mb-3'>
                <u className='green' style={{ cursor: 'pointer', fontSize: '14px' }}>Forgot Password?</u>
              </div>

              <Button type='submit' className='login_signin_btn w-100 d-flex align-items-center justify-content-center gap-2' disabled={spinner}>
                {spinner ?
                  <ButtonLoader />
                  :
                  <>SIGN IN <ArrowRight size={18} /></>
                }
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-center border-0" style={{ backgroundColor: 'unset' }}>
            <span style={{ fontSize: '13px' }} className='text-muted'>By continuing, you agree to our <u className='green' style={{ cursor: 'pointer' }}>Terms of Service</u> and <u className='green' style={{ cursor: 'pointer' }}>Privacy Policy</u>.</span>
          </Card.Footer>
        </Card>
      </Form>
    </>
  )
}
